import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SxInputFileComponent } from './components/sx-input-file/sx-input-file.component';
import { PortalModule } from '@angular/cdk/portal';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FileUploadComponent } from './components/file-upload/file-upload.component';

@NgModule({
  declarations: [SxInputFileComponent, FileUploadComponent],
  imports: [
    CommonModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    FlexLayoutModule,
    PortalModule,
  ],
  exports: [SxInputFileComponent, FileUploadComponent],
  providers: [],
})
export class UiModule {}
